import { colors, fonts } from "../../styles/theme";
import { Button } from "../../components/ui";

export default function EditContactForm({ form, onChange, onSave, onCancel, saving }) {
  const inputStyle = {
    width: "100%",
    padding: "8px 12px",
    borderRadius: 6,
    border: `1px solid ${colors.border}`,
    background: colors.bgCard,
    color: colors.text,
    fontFamily: fonts.body,
    fontSize: 13,
    boxSizing: "border-box",
  };
  const labelStyle = {
    fontSize: 11,
    color: colors.textSecondary,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    marginBottom: 4,
    display: "block",
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
        <div>
          <label style={labelStyle}>First Name</label>
          <input style={inputStyle} value={form.firstName} onChange={(e) => onChange({ ...form, firstName: e.target.value })} />
        </div>
        <div>
          <label style={labelStyle}>Last Name</label>
          <input style={inputStyle} value={form.lastName} onChange={(e) => onChange({ ...form, lastName: e.target.value })} />
        </div>
      </div>
      <div style={{ marginBottom: 12 }}>
        <label style={labelStyle}>Company</label>
        <input style={inputStyle} value={form.company} onChange={(e) => onChange({ ...form, company: e.target.value })} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <label style={labelStyle}>Job Title</label>
        <input style={inputStyle} value={form.jobTitle} onChange={(e) => onChange({ ...form, jobTitle: e.target.value })} />
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
        <div>
          <label style={labelStyle}>Email</label>
          <input style={{ ...inputStyle, opacity: 0.6 }} value={form.email} disabled title="Email cannot be changed" />
        </div>
        <div>
          <label style={labelStyle}>Phone</label>
          <input style={inputStyle} value={form.phone} onChange={(e) => onChange({ ...form, phone: e.target.value })} />
        </div>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <Button variant="primary" onClick={onSave} disabled={saving} style={{ fontSize: 12 }}>
          {saving ? "Saving..." : "Save"}
        </Button>
        <Button variant="default" onClick={onCancel} disabled={saving} style={{ fontSize: 12 }}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
